import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TextInputModule} from "@pb-labs/text-input";
import {ButtonModule} from "@pb-labs/button";
import {LoaderModule} from "@pb-labs/loader";
import {LoginComponent} from "@app/modules/login/login.component";
import {AppConfig} from "@app/services/app.config";
import {SFTPAPIService} from "@app/services/sftp-api/sftp-api.service";
import {AuthorizationService} from "@app/services/authorization.service";
import {ApplicationEnvironmentMessageModule} from "@app/shared/components/application-environment-message/application-environment-message.module";

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, TextInputModule, ButtonModule, LoaderModule, ApplicationEnvironmentMessageModule],
  providers: [AppConfig, SFTPAPIService, AuthorizationService],
  exports: [LoginComponent],
})
export class LoginModule {}
